export default __webpack_public_path__ + "static/media/allen.5ff6f07d.jpeg";